import strings from '../../strings'

export const formatPlayPauseLabel = (isPlaying: boolean, title: string) => {
	if (isPlaying) {
		return title ? strings.formatString(strings.accessibility_pause_audio_s, { title }) as string : strings.pause_media
	} else {
		return title ? strings.formatString(strings.accessibility_play_audio_s, { title }) as string : strings.play_media
	}
}
